<template>
  <div class="linked-documents-wrap fe_fileexplorer_wrap">
    <div class="fe_fileexplorer_items_wrap">
      <div
        v-for="document in normalizedDocuments"
        :key="document.id"
        class="fe_fileexplorer_item_wrap"
        @click.stop="openFile(document.id)"
      >
        <div class="fe_fileexplorer_item_wrap_inner">
          <div
            class="fe_fileexplorer_item_icon"
            :class="
              document.type === 'folder'
                ? 'fe_fileexplorer_item_icon_folder'
                : [
                    !document.showThumbnail && 'fe_fileexplorer_item_icon_file',
                    document.extColorClass,
                    !document.ext && 'fe_fileexplorer_item_icon_file_no_ext',
                  ]
            "
            :data-ext="document.ext"
          >
            <img
              v-if="document.showThumbnail"
              :src="document.thumbnailUrl"
              :alt="document.name"
            />
          </div>
          <div class="fe_fileexplorer_item_text" :title="document.name">
            {{ document.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DIJVueConfigurations from '../../../helpers/DIJVueConfigurations';
import client from '../../../config/api';

export default {
  name: 'LinkedDocuments',
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    normalizedDocuments() {
      return this.documents
        .map((document) => {
          if (!document) return null;

          const id = document._id;
          const { name } = document;

          const ext = this.getFileExt(name);
          const thumbnailUrl = this.getImageUrl(document.filePath);

          return {
            id,
            name,
            type: document.type,
            ext,
            extColorClass: this.getExtColorClass(ext),
            thumbnailUrl,
            showThumbnail: this.isImageExt(ext) && !!thumbnailUrl,
          };
        })
        .filter(Boolean);
    },
  },
  methods: {
    getFileExt(name) {
      if (!name || typeof name !== 'string' || name.indexOf('.') === -1) {
        return '';
      }

      return name.split('.').pop().toLowerCase();
    },

    getExtColorClass(ext) {
      if (!ext) return '';

      const firstChar = ext.charAt(0).toLowerCase();

      if (/^[a-z0-9]$/.test(firstChar)) {
        return `fe_fileexplorer_item_icon_ext_${firstChar}`;
      }
      return '';
    },

    isImageExt(ext) {
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext);
    },

    getImageUrl(url) {
      if (!url) return null;
      if (Array.from(url)[0] !== '/') url = `/${url}`;

      const lastPart = url.split('/').pop();
      const allButLast = url.split('/').slice(0, -1).join('/');
      url = `${allButLast}/${encodeURIComponent(lastPart)}`;

      // For local env we need to point to the local s3
      if (window.location.host.includes('localhost')) {
        return `http://localhost:4566/images${url}`;
      }

      return url;
    },

    async openFile(documentId) {
      const doc = this.documents.find((d) => d._id === documentId);
      let path = doc.filePath;
      if (doc.type === 'file') {
        if (Array.from(path)[0] === '/') {
          path = path.substring(1);
        }
        const dijConfigurations = new DIJVueConfigurations();
        const response = await client.post(
          `/job/${doc.jobId}/reportfile-download-url`,
          { key: path, bucketName: dijConfigurations.bucket }
        );

        const anchor = document.createElement('a');
        anchor.style.display = 'none';
        anchor.href = response.data;
        anchor.target = '_blank';
        anchor.setAttribute('download', '');

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      }

      if (doc.type === 'url') {
        let url = (doc.filePath || '').trim();

        if (!/^https?:\/\//i.test(url)) {
          url = `https://${url}`;
        }

        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
  },
};
</script>

<style>
@import '../../../../public/file-explorer.css';

.linked-documents-wrap {
  width: 100%;
}

.linked-documents-wrap .fe_fileexplorer_inner_wrap {
  border: none;
}

.linked-documents-wrap .fe_fileexplorer_items_scroll_wrap {
  max-height: 360px;
}

.fe_fileexplorer_item_wrap {
  cursor: pointer;
}
</style>
